<template>
  <footer class="page-footer">
    <nav>
      <template v-for="item,key,i in portfolio">
      <a :href="'/portfolio/' + item.id" :key="item.title">
        {{ item.title }}
      </a>
      <span v-if="i != length">/</span>
      </template>
    </nav>
    <p class="copy">Copyright © {{year}} TaiDesign</p>
  </footer>
</template>

<script>
  import Portfolio from '../portfolio.json';

  export default {

    components: {},
    props: {
      id: String,
      name: String,
    },

    data () {
      return {
        portfolio: Portfolio,
        length: Object.keys(Portfolio).length - 1,
        year: (new Date()).getFullYear()
      }
    },
  }
</script>

<style lang="scss">
  @import "../../css/footer.scss";
</style>


// WEBPACK FOOTER //
// footer.vue?463d8bd1